import type { ButtonProps, TooltipProps } from '@neo4j-ndl/react';
import { Button, IconButton, Tooltip } from '@neo4j-ndl/react';
import { FolderIconOutline } from '@neo4j-ndl/react/icons';
import { useOpenDirectoryMutation } from '@nx/state/desktop';

/**
 * This is meant to be used only in Desktop, as it requires the Electron backend
 * to work properly.
 */
export function OpenPathButton({
  path,
  children,
  size,
}: { path: string[]; children: React.ReactNode } & Pick<ButtonProps, 'size'>) {
  const [openDirectory] = useOpenDirectoryMutation();

  return (
    <Button
      size={size ?? 'small'}
      fill="outlined"
      color="neutral"
      className="text-nowrap"
      onClick={() => {
        void openDirectory(path);
      }}
    >
      {children}
    </Button>
  );
}

type OpenPathIconButtonProps = {
  path: string;
  title?: string;
  tooltipPlacement?: TooltipProps['placement'];
} & Pick<ButtonProps, 'size'>;
export const OpenPathIconButton = ({ path, size, title, tooltipPlacement }: OpenPathIconButtonProps) => {
  const [openDirectory] = useOpenDirectoryMutation();

  return (
    <Tooltip type="simple" placement={tooltipPlacement ?? 'left'}>
      <Tooltip.Trigger hasButtonWrapper>
        <IconButton
          ariaLabel={title ?? 'Open path'}
          size={size}
          onClick={() => {
            void openDirectory([path]);
          }}
          isClean
        >
          <FolderIconOutline />
        </IconButton>
      </Tooltip.Trigger>
      <Tooltip.Content className="n-body-small">{title ?? 'Open path'}</Tooltip.Content>
    </Tooltip>
  );
};
